<template>
  <v-app-bar id="app-toolbar" class="position-fixed pa-2" theme="dark" color="grey-darken-3">
    <v-app-bar-nav-icon @click="toggleDrawer()" />

    <!-- LOGO -->
    <a v-if="$vuetify.display.mdAndUp" id="logo" title="WhaleWisdom Home Page" href="/">
      <img src="@/assets/images/main-logo.png" alt="WhaleWisdom logo" />
    </a>

    <!-- TEST BREAKPOINT INDICATOR -->
    <!-- <div class="text-h5 text-uppercase ml-2">{{ $vuetify.display.name }}</div> -->
    <!-- END TEST BREAKPOINT INDICATOR -->

    <v-spacer />
    <toolbar-search />
    <v-spacer />
    <toolbar-frequently-used />
    <toolbar-account />
  </v-app-bar>
</template>

<script>
// Components
import ToolbarSearch from './toolbar/_Search'
import ToolbarFrequentlyUsed from './toolbar/_FrequentlyUsed'
import ToolbarAccount from './toolbar/_Account'
import { useAppStore } from '@/store'

export default {
  components: {
    ToolbarSearch,
    ToolbarFrequentlyUsed,
    ToolbarAccount
  },
  methods: {
    toggleDrawer() {
      useAppStore().toggleDrawer()
    }
  }
}
</script>

<style lang="scss">
#app-toolbar {
  #logo img {
    height: 32px;
    vertical-align: middle;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
